"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useOnlineStatus } from "@/utils/hooks/useOnlineStatus";

export function OfflineDialog() {
  const isOnline = useOnlineStatus();

  return (
    <Dialog open={!isOnline}>
      <DialogContent type="danger">
        <DialogHeader>
          <DialogTitle>Sin conexión a internet</DialogTitle>
          <DialogDescription>
            Perdiste la conexión. Este mensaje se cerrará solo cuando vuelva la
            conexión.
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
